/**
 * Copy shared by the Configure → Company pages.
 *
 * The group has two rows — Overview (host) and Security (plugin-auth-oidc) —
 * and they must state their scope identically: an admin who reads "settings
 * for every organization in your company" on one page and something narrower
 * on the other has been told the blast radius changes between them, which is
 * the confusion the Company group exists to end. One string, one home, no
 * import from `web/src` needed to reach it.
 */

/**
 * The sentence under every Company page header. Says whose settings these
 * are; each page's title says which of them it holds.
 */
export const COMPANY_SCOPE_DESCRIPTION =
  'Configure settings for every organization in your company.';

/** Header title for Company → Overview before the company's name is known. */
export const COMPANY_FALLBACK_TITLE = 'Company';
